import { Fragment } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { useParams } from "react-router";

import { Breadcrumbs, PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { StyledEmptyWrapper, StyledPagination } from "@framework/styled";
import { IContract } from "@framework/types";
import { IPaginationResult } from "@dzambalaorg/types-collection";
import { useFetchQuery } from "@dzambalaorg/react-hooks";

import { ContractListItem } from "../../../../components";

export interface IContractListProps {
  embedded?: boolean;
}

export const ContractList = (props: IContractListProps) => {
  const { embedded } = props;

  const { id } = useParams<{ id: string }>();

  const isMd = useMediaQuery(theme => theme.breakpoints.down("md"));

  const { isLoading, take, skip, onChangePage, hasNextPage, loadMoreRef, allRows, totalCount } = useFetchQuery<
    IPaginationResult<IContract>
  >("/contracts", { enableInfiniteScroll: isMd, embedded }, void 0, {
    merchantId: embedded ? ~~id! : void 0,
  });

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "marketplace", "marketplace.contracts"]} isHidden={embedded} />

      <PageHeader message="pages.marketplace.contracts.title" />

      <ProgressOverlay isLoading={isLoading}>
        <Grid container spacing={2}>
          <StyledEmptyWrapper count={allRows.length} isLoading={isLoading}>
            {allRows.map(contract => (
              <Grid display="flex" size={{ lg: 4, sm: 6, xs: 12 }} key={contract.id}>
                <ContractListItem contract={contract} path={"/marketplace/contracts"} />
              </Grid>
            ))}
          </StyledEmptyWrapper>
        </Grid>
      </ProgressOverlay>

      {!isMd && totalCount > take && (
        <StyledPagination
          shape="rounded"
          page={skip / take + 1}
          count={Math.ceil(totalCount / take)}
          onChange={onChangePage}
        />
      )}
      {isMd && hasNextPage && <div ref={loadMoreRef} style={{ height: "20px", margin: "20px 0" }} />}
    </Fragment>
  );
};
